import axios from "axios";
import { CheckLoginServer } from "../Helpers/CheckLogin";
import { BaseUrl } from "./Base";

const axiosInstance = axios.create({
    baseURL: BaseUrl,
    withCredentials: true,
});

export const GetStudentsA = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetStudentsListRequest",
        });

        const { data } = await axiosInstance.get(`/api/Enrolled/students`);

        dispatch({
            type: "GetStudentsListSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentsListError",
            payload: error,
        });
    }
};

export const GetSingleInstituteAllLearnersA = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetStudentsListRequest",
        });

        const { data } = await axiosInstance.get(`/api/SingleInstitute/AllLearners`);

        dispatch({
            type: "GetStudentsListSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentsListError",
            payload: error,
        });
    }
};

export const GetSingleInstituteAllCoursesWithPackagesA = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetSingleInstituteAllCoursesWithPackagesRequest",
        });

        const { data } = await axiosInstance.get(`/api/SingleInstitute/AllCoursesWithPackages`);

        dispatch({
            type: "GetSingleInstituteAllCoursesWithPackagesSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetSingleInstituteAllCoursesWithPackagesFailure",
            payload: error,
        });
    }
};

export const GetInstituteAllUsersActivityLogsA = (InstituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetInstituteAllUsersActivityLogsRequest",
        });

        const { data } = await axiosInstance.get(`/api/Institute/AllUsersActivityLogs/${InstituteId}`);

        dispatch({
            type: "GetInstituteAllUsersActivityLogsSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetInstituteAllUsersActivityLogsFailure",
            payload: error,
        });
    }
};

export const CreateLearnerCourseEnrollmentFromInstituteA = (formData, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "CreateLearnerCourseEnrollmentFromInstituteRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/SingleInstitute/LearnerCourseEnrollmentRequest`,
            formData,
        );
        dispatch({
            type: "CreateLearnerCourseEnrollmentFromInstituteSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "CreateLearnerCourseEnrollmentFromInstituteFailure",
            payload: error,
        });
    }
};

//Student list Enrollment Status Inprogress
export const GetStatusInProgressStudentsA = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetStatusInProgressStudentsListRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/Enrolled/StatusInProgress/students`
        );

        dispatch({
            type: "GetStatusInProgressStudentsListSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStatusInProgressStudentsListError",
            payload: error,
        });
    }
};

//GET Students with Course Enrollment status on Hold
export const GetStatusHoldStudentsA = () => async (dispatch) => {
    try {
        dispatch({
            type: "etStatusHoldStudentsListRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/Enrolled/StatusHold/students`
        );

        dispatch({
            type: "GetStatusHoldStudentsListSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStatusHoldStudentsListError",
            payload: error,
        });
    }
};

export const GetClassScheduleA = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetClassScheduleRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/course/schedule/${EnrollmentId}`
        );
        dispatch({
            type: "GetClassScheduleSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetClassScheduleError",
            payload: error,
        });
    }
};

export const GetLearnerAutomaticClassesScheduleA = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetLearnerAutomaticClassesScheduleRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/learner/automaticschedule/${EnrollmentId}`
        );
        dispatch({
            type: "GetLearnerAutomaticClassesScheduleSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetLearnerAutomaticClassesScheduleFailure",
            payload: error,
        });
    }
};

export const GetStudentAllCoursesScheduleA = (studentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetStudentAllCoursesClassScheduleRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/studentallcourses/schedule/${studentId}`
        );
        dispatch({
            type: "GetStudentAllCoursesClassScheduleSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentAllCoursesClassScheduleFailure",
            payload: error,
        });
    }
};

// export const GetProgressAndCourse = (EnrollmentId) => async (dispatch) => {
//     try {
//         dispatch({
//             type: "GetAboutClientRequest",
//         });

//         const { data } = await axiosInstance.get(
//             `/api/courseprogress/${EnrollmentId}`
//         );
//         dispatch({
//             type: "GetAboutClientSuccess",
//             payload: data,
//         });
//     } catch (error) {
//         CheckLoginServer(error?.response?.data, dispatch);
//         dispatch({
//             type: "GetAboutClientError",
//             payload: error,
//         });
//     }
// };

export const CreateScheduleA = (Events,cb, errorCb) => async (dispatch) => {
    try {
        dispatch({
            type: "CreateStudentClassesScheduleRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/schedule/create`,
            Events
        );
        dispatch({
            type: "CreateStudentClassesScheduleSuccess",
            payload: data,
        });
        cb();

    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "CreateStudentClassesScheduleFailure",
            payload: error,
        });
        if (errorCb) errorCb(error?.response?.data?.message || "Something went wrong"); // ✅ error callback
    }
};

export const UpdateScheduleA = ({Events, LearnerId, date, dateNum, time}) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateScheduleRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/schedule/update`,
            {
                Events,
                LearnerId,
                date, dateNum, time
            }
        );
        dispatch({
            type: "UpdateScheduleSuccess",
            payload: data,
        });
        return { success: true }; // ✅ Return success status
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateScheduleFailure",
            payload: error,
        });
        return { success: false }; // ✅ Return failure status
    }
};

export const ChangeScheduleStatus = (EventId, status, ClassFeedback, UserId, UserType, InstituteId, LearnerId, ip, instructorId, startDate, endDate, courseName) => async (dispatch) => {
    console.log("startDate received",startDate)

    try {
        dispatch({
            type: "ChangeScheduleStatusRequest",
        });

        // Send EventId and status in the request body
        const { data } = await axiosInstance.put(
            `/api/schedule/changestatus`,
            { EventId, status, ClassFeedback, UserId, UserType, InstituteId, LearnerId, ip, instructorId, startDate, endDate, courseName }  // Send as an object
        );

         // Log the response data to ensure it's structured correctly
         console.log("Response data:", data);


        dispatch({
            type: "ChangeScheduleStatusSuccess",
            payload: data,  // Assuming data contains the updated schedule
        });

        return { success: true, data }; // ✅ Return success status

    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        
        dispatch({
            type: "ChangeScheduleStatusFailure",
            payload: error?.response?.data?.message || error.message, // Provide a specific error message
        });

        return { success: false, error }; // ✅ Return failure status

    }
};

export const ChangeInClassBatchTimeTableStatus = (EventId, status, ClassFeedback) => async (dispatch) => {
    try {
        dispatch({
            type: "ChangeScheduleStatusRequest",
        });

        // Send EventId and status in the request body
        const { data } = await axiosInstance.put(
            `/api/InClassBatchTimeTable/changestatus`,
            { EventId, status, ClassFeedback }  // Send as an object
        );

         // Log the response data to ensure it's structured correctly
         console.log("Response data:", data);


        dispatch({
            type: "ChangeScheduleStatusSuccess",
            payload: data,  // Assuming data contains the updated schedule
        });

        return { success: true, data }; // ✅ Return success status

    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        
        dispatch({
            type: "ChangeScheduleStatusFailure",
            payload: error?.response?.data?.message || error.message, // Provide a specific error message
        });

        return { success: false, error }; // ✅ Return failure status

    }
};

export const MarkAllbatchStudentsAsPresent = (EventId, status) => async (dispatch) => {
    try {
        dispatch({
            type: "ChangeScheduleStatusRequest",
        });

        // Send EventId and status in the request body
        const { data } = await axiosInstance.put(
            `/api/MarkAllbatchStudentsAsPresent/changestatus`,
            { EventId, status }  // Send as an object
        );

         // Log the response data to ensure it's structured correctly
         console.log("Response data:", data);


        dispatch({
            type: "ChangeScheduleStatusSuccess",
            payload: data,  // Assuming data contains the updated schedule
        });

        return { success: true, data }; // ✅ Return success status

    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        
        dispatch({
            type: "ChangeScheduleStatusFailure",
            payload: error?.response?.data?.message || error.message, // Provide a specific error message
        });

        return { success: false, error }; // ✅ Return failure status

    }
};

export const MarkBatchSingleStudentAttendance = (EventId, enrollmentId, status, classOtpStatus, feedback) => async (dispatch) => {
    try {
        dispatch({
            type: "ChangeScheduleStatusRequest",
        });

        // Send EventId and status in the request body
        const { data } = await axiosInstance.put(
            `/api/MarkBatchSingleStudentAttendance/changestatus`,
            { EventId, enrollmentId, status, classOtpStatus, feedback }  // Send as an object
        );

         // Log the response data to ensure it's structured correctly
         console.log("Response data:", data);


        dispatch({
            type: "ChangeScheduleStatusSuccess",
            payload: data,  // Assuming data contains the updated schedule
        });

        return { success: true, data }; // ✅ Return success status

    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        
        dispatch({
            type: "ChangeScheduleStatusFailure",
            payload: error?.response?.data?.message || error.message, // Provide a specific error message
        });

        return { success: false, error }; // ✅ Return failure status

    }
};

export const SendAttendanceOTPtoLearner = (Email, otp, FirstName, LastName, BatchName, ClassNo) => async (dispatch) => {
    try {
        dispatch({
            type: "ChangeScheduleStatusRequest",
        });

        // Send EventId and status in the request body
        const { data } = await axiosInstance.post(
            `/api/SendAttendanceOTPtoLearner`,
            { Email, otp, FirstName, LastName, BatchName, ClassNo }  // Send as an object
        );

         // Log the response data to ensure it's structured correctly
         console.log("Response data:", data);


        dispatch({
            type: "ChangeScheduleStatusSuccess",
            payload: data,  // Assuming data contains the updated schedule
        });

        return { success: true, data }; // ✅ Return success status

    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        
        dispatch({
            type: "ChangeScheduleStatusFailure",
            payload: error?.response?.data?.message || error.message, // Provide a specific error message
        });

        return { success: false, error }; // ✅ Return failure status

    }
};

export const GetScheduleA = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetTimeTableRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/timetable/${EnrollmentId}`
        );
        dispatch({
            type: "GetTimeTableSuccess",
            payload: data,
        });
        
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetTimeTableError",
            payload: error,
        });
    }
};

export const GetLearnerTimeTableForSpecificInstructorA = (EnrollmentId, InstructorId) => async (dispatch) => {
    try {
      dispatch({ type: "GetTimeTableRequest" });
  
      const { data } = await axiosInstance.post(
        `/api/learnertimetablewithinstructor/${EnrollmentId}`,
        { InstructorId } // 👈 sent in body
      );
  
      dispatch({
        type: "GetTimeTableSuccess",
        payload: data,
      });
    } catch (error) {
      CheckLoginServer(error?.response?.data, dispatch);
      dispatch({
        type: "GetTimeTableError",
        payload: error,
      });
    }
  };
  

export const GetInClassBatchNameA = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetBatchNameRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/InClassBatchName/${EnrollmentId}`
        );
        dispatch({
            type: "GetBatchNameSuccess",
            payload: data,
        });
        
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetBatchNameFailure",
            payload: error,
        });
    }
};

export const GetCourseNameA = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetCourseNameRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/GetCourseName/${EnrollmentId}`
        );
        dispatch({
            type: "GetCourseNameSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetCourseNameFailure",
            payload: error,
        });
    }
};

export const GetSubscriptionStatus = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "SubscriptionRequest",
        });
        const { data } = await axiosInstance.get(
            `/api/Status/payment/${EnrollmentId}`
        );

        dispatch({
            type: "SubscriptionSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "SubscriptionFailure",
            payload: error,
        });
    }
};

// Action to get user by ID
export const GetUserByIdA = (userId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetUserByIdRequest",
        });

        console.log("user id in action is:", userId)

        const { data } = await axiosInstance.get(`/api/getuserbyid/${userId}`);

        dispatch({
            type: "GetUserByIdSuccess",
            payload: data,
        });
    } catch (error) {
       // Serialize the error
       const serializedError = {
        message: error.message,
        code: error.code,
        response: error.response ? {
            status: error.response.status,
            data: error.response.data,
        } : null,
    };
        dispatch({
            type: "GetUserByIdFailure",
            payload: serializedError,

        });
    }
};

//update student settings field at the backend
export const UpdateSettingsField = (UserId,formData) => async (dispatch) => {
    try {
        console.log("UserId in UpdateSettingsField action is:", UserId)
        console.log("formData in UpdateSettingsField action is:", formData)

        dispatch({
            type: "UpdateSettingsFieldsRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/${UserId}`,
            formData
        );

        dispatch({
            type: "UpdateSettingsFieldsSuccess",
            payload: data,
        });
        return Promise.resolve(); // Indicate success
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateSettingsFieldsFailure",
            payload: error,
        });
        return Promise.reject(); // Indicate failure
    }
};

//Get student Notification data
export const GetStudentNotificationData = (UserId) => async (dispatch) => {
    try {
        console.log("UserId in GetStudentNotificationData action is:", UserId)

        dispatch({
            type: "GetStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/NotificationsData/${UserId}`
        );

        dispatch({
            type: "GetStudentNotificationDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentNotificationDataFailure",
            payload: error,
        });
    }
};

//Get student GetStudentAllTheNotificationsReceived data
export const GetStudentAllTheNotificationsReceived = (UserId, UserType) => async (dispatch) => {
    try {
        console.log("UserId in GetStudentAllTheNotificationsReceived action is:", UserId)

        dispatch({
            type: "GetStudentAllTheNotificationsReceivedRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/learner/settings/NotificationsReceived/${UserId}`,
            {UserType}
        );

        dispatch({
            type: "GetStudentAllTheNotificationsReceivedSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentAllTheNotificationsReceivedFailure",
            payload: error,
        });
    }
};

//Update student Notification Personal data
export const UpdateStudentPersonalNotificationData = (UserId, notifications, cb) => async (dispatch) => {
    try {
        console.log("UserId in UpdateStudentPersonalNotificationData action is:", UserId)
        console.log("notifications in UpdateStudentPersonalNotificationData action is:", notifications)

        dispatch({
            type: "UpdateStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/UpdateNotificationsData/${UserId}`,
            { notifications }
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });
    }
};

//UpdateUserPaymentMethod data
// export const UpdateUserPaymentMethod = (dataToSend, UserId, cb) => async (dispatch) => {
//     try {
//         console.log("UserId in UpdateUserPaymentMethod action is:", UserId)
//         console.log("dataToSend in UpdateUserPaymentMethod action is:", dataToSend)

//         dispatch({
//             type: "UpdateStudentNotificationDataRequest",
//         });
//         const { data } = await axiosInstance.post(
//             `/api/student/settings/UpdateUserPaymentMethod/${UserId}`,
//             { dataToSend }
//         );

//         dispatch({
//             type: "UpdateStudentNotificationDataSuccess",
//             payload: data,
//         });
//         cb();
//         // return Promise.resolve(); // Indicate success
//     } catch (error) {
//         CheckLoginServer(error?.response?.data, dispatch);
//         dispatch({
//             type: "UpdateStudentNotificationDataFailure",
//             payload: error,
//         });
//         // return Promise.reject(); // Indicate failure
        
//     }
// };

export const UpdateUserPaymentMethod = (dataToSend, UserId, onSuccess, onError) => async (dispatch) => {
    try {
        dispatch({ type: "UpdateStudentNotificationDataRequest" });

        const { data } = await axiosInstance.post(
            `/api/student/settings/UpdateUserPaymentMethod/${UserId}`,
            { dataToSend }
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });

        onSuccess(); // success callback
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });

        const errorMsg = error?.response?.data?.message || "An error occurred while updating the payment method.";
        onError(errorMsg); // failure callback
    }
};


//GetUserPaymentMethod data
export const GetUserPaymentMethod = (UserId) => async (dispatch) => {
    try {
        console.log("UserId in GetUserPaymentMethod action is:", UserId)

        dispatch({
            type: "GetUserPaymentMethodDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/GetUserPaymentMethod/${UserId}`
        );

        dispatch({
            type: "GetUserPaymentMethodDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetUserPaymentMethodDataFailure",
            payload: error,
        });
    }
};

//GetUserPaymentMethod data
export const UpdateUserPaymentDefaultField = (UserId, paymentMethodId) => async (dispatch) => {
    try {
        console.log("UserId in UpdateUserPaymentDefaultField action is:", UserId)
        console.log("paymentMethodId in UpdateUserPaymentDefaultField action is:", paymentMethodId)

        dispatch({
            type: "UpdateStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/UpdateUserPaymentDefaultField/${UserId}`,
            {paymentMethodId}
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });
        return Promise.resolve(); // Indicate success
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });
        return Promise.reject(); // Indicate failure

    }
};

//UpdateSettingsOpenDisputeTable data
export const UpdateSettingsOpenDisputeTable = (UserId,formData) => async (dispatch) => {
    try {
        console.log("UserId in UpdateSettingsOpenDisputeTable action is:", UserId)
        console.log("formData in UpdateSettingsOpenDisputeTable action is:", formData)

        dispatch({
            type: "UpdateStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/UpdateSettingsOpenDisputeTable/${UserId}`,
            formData
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });
        return Promise.resolve(); // Indicate success
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });
        return Promise.reject(); // Indicate failure
    }
};

//GetSettingsOpenDisputeTable data
export const GetSettingsOpenDisputeData = (UserId) => async (dispatch) => {
    try {
        console.log("UserId in GetSettingsOpenDisputeData action is:", UserId)

        dispatch({
            type: "GetSettingsOpenDisputeDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/settings/GetSettingsOpenDisputeData/${UserId}`
        );

        dispatch({
            type: "GetSettingsOpenDisputeDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetSettingsOpenDisputeDataFailure",
            payload: error,
        });
    }
};

//get institute info from the database
export const GetInstituteInformation = (InstituteId) => async (dispatch) => {
    try {
        console.log("InstituteId in GetInstituteInformation action is:", InstituteId)

        dispatch({
            type: "GetInstituteInformationRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/getinstituteinfo/${InstituteId}`
        );

        dispatch({
            type: "GetInstituteInformationSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetInstituteInformationFailure",
            payload: error,
        });
    }
};

//get institute info from the database
export const GetInstituteAddressInformation = (InstituteId) => async (dispatch) => {
    try {
        console.log("InstituteId in GetInstituteAddressInformation action is:", InstituteId)

        dispatch({
            type: "GetInstituteAddressInformationRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/getinstituteaddressinfo/${InstituteId}`
        );

        dispatch({
            type: "GetInstituteAddressInformationSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetInstituteAddressInformationFailure",
            payload: error,
        });
    }
};

//get one institute all courses
export const GetOneInstituteAllCourses = (InstituteId) => async (dispatch) => {
    try {
        console.log("InstituteId in GetOneInstituteAllCourses action is:", InstituteId)

        dispatch({
            type: "GetOneInstituteAllCoursesDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/getoneinstitutecoursesinfo/${InstituteId}`
        );

        dispatch({
            type: "GetOneInstituteAllCoursesDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetOneInstituteAllCoursesDataFailure",
            payload: error,
        });
    }
};

//get one institute Training Stats
export const GetOneInstituteTrainingStats = (InstituteId) => async (dispatch) => {
    try {
        console.log("InstituteId in GetOneInstituteTrainingStats action is:", InstituteId)

        dispatch({
            type: "GetOneInstituteTrainingStatsDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/student/GetOneInstituteTrainingStats/${InstituteId}`
        );

        dispatch({
            type: "GetOneInstituteTrainingStatsDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetOneInstituteTrainingStatsDataFailure",
            payload: error,
        });
    }
};

//GetFeedbackPageData data
export const GetFeedbackPageData = (EnrollmentId) => async (dispatch) => {
    try {
        console.log("EnrollmentId in GetFeedbackPageData action is:", EnrollmentId)

        dispatch({
            type: "GetFeedbackPageDataRequest",
        });
        const { data } = await axiosInstance.get(
            `/api/GetFeedbackPageData/${EnrollmentId}`,
        );

        dispatch({
            type: "GetFeedbackPageDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetFeedbackPageDataFailure",
            payload: error,
        });
    }
};

//UpdateSettingsOpenDisputeTable data
export const UpdateFeedbackDataInDatabase = (feedbackPayload, EnrollmentId) => async (dispatch) => {
    try {
        console.log("feedbackPayload in GetFeedbackPageData action is:", feedbackPayload)
        console.log("EnrollmentId in GetFeedbackPageData action is:", EnrollmentId)

        dispatch({
            type: "UpdateFeedbackPageDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/UpdateFeedbackPageData/${EnrollmentId}`,
            feedbackPayload
        );

        dispatch({
            type: "UpdateFeedbackPageDataSuccess",
            payload: data,
        });
        return Promise.resolve(); // Indicate success
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateFeedbackPageDataFailure",
            payload: error,
        });
        return Promise.reject(); // Indicate failure
    }
};

export const GetVLIAgentsA = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetVLIAgentsARequest",
        });

        const { data } = await axiosInstance.post(`/api/GetVLIAgentsA`);

        dispatch({
            type: "GetVLIAgentsASuccess",
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: "GetVLIAgentsAError",
            payload: error,
        });
    }
};

export const UpdateVLIAgentsReferrals = (AgentName,AgentId) => async (dispatch) => {
    console.log("AgentName in UpdateVLIAgentsReferrals is:",AgentName)
    console.log("AgentId in UpdateVLIAgentsReferrals is:",AgentId)

    try {
        dispatch({
            type: "UpdateVLIAgentsRequest",
        });

        const { data } = await axiosInstance.post(`/api/UpdateVLIAgentsReferrals`,{
            AgentId,
            AgentName
        });

        dispatch({
            type: "UpdateVLIAgentsSuccess",
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: "UpdateVLIAgentsError",
            payload: error,
        });
    }
};

export const GetInstitutePackagesDetails = () => async (dispatch) => {
    try {
        dispatch({
            type: "GetInstitutePackagesDetailsRequest",
        });

        const { data } = await axiosInstance.post(`/api/GetInstitutePackagesDetails`);

        dispatch({
            type: "GetInstitutePackagesDetailsSuccess",
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: "GetInstitutePackagesDetailsError",
            payload: error,
        });
    }
};

export const FetchInstituteTrainingAndOfficeHours = (instituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "FetchInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/FetchInstituteTrainingAndOfficeHours/${instituteId}`
        );

        dispatch({
            type: "FetchInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "FetchInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const UpdateInstituteTrainingAndOfficeHours = (officeSlots, trainingSlots, instituteId, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/UpdateInstituteTrainingAndOfficeHours/${instituteId}`,
             {
                officeSlots,
                trainingSlots,
            }
        );

        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const UpdateInstituteAutomaticHours = (automaticSchedule, instituteId, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/UpdateInstituteAutomaticHours/${instituteId}`,
             {
                automaticSchedule
            }
        );

        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const FetchInstituteInClassAndBatchTimings = (instituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "FetchInstituteInClassAndBatchTimingsRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/FetchInstituteInClassAndBatchTimings/${instituteId}`
        );

        dispatch({
            type: "FetchInstituteInClassAndBatchTimingsSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "FetchInstituteInClassAndBatchTimingsError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const FetchInstituteSigleInClassBatchDetailsAndTimetables = (InstituteInClassAndBatchTimingId) => async (dispatch) => {
    try {
        dispatch({
            type: "FetchInstituteSigleInClassBatchDetailsAndTimetablesRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/FetchInstituteSingleInClassBatchDetailsAndTimetable/${InstituteInClassAndBatchTimingId}`
        );

        dispatch({
            type: "FetchInstituteSigleInClassBatchDetailsAndTimetablesSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "FetchInstituteSigleInClassBatchDetailsAndTimetablesError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const FetchInClassBatchLearnersDetailsAndTimetables = (InstituteInClassAndBatchTimingId) => async (dispatch) => {
    try {
        dispatch({
            type: "FetchInClassBatchLearnersDetailsAndTimetablesRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/FetchInClassBatchLearnersDetailsAndTimetables/${InstituteInClassAndBatchTimingId}`
        );

        dispatch({
            type: "FetchInClassBatchLearnersDetailsAndTimetablesSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "FetchInClassBatchLearnersDetailsAndTimetablesError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const UpdateInstituteInClassAndBatchTimings = (inClassBatchesList, instituteId, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/UpdateInstituteInClassAndBatchTimings/${instituteId}`,
             {
                inClassBatchesList
            }
        );

        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const DeleteInstituteInClassAndBatchTimings = (batchToDelete, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "DeleteInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/DeleteInstituteInClassAndBatchTimings`,
             {
                batchToDelete
            }
        );

        dispatch({
            type: "DeleteInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "DeleteInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const UpdateSingleInstituteInClassAndBatchTimings = (updatedBatch, editingBatchId, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/UpdateSingleInstituteInClassAndBatchTimings/${editingBatchId}`,
             {
                updatedBatch
            }
        );

        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const UpdateSingleInstituteInClassAndBatchInstructor = (InstituteInClassAndBatchTimingId, instructorId, label, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/UpdateSingleInstituteInClassAndBatchInstructor/${InstituteInClassAndBatchTimingId}`,
             {
                instructorId, label
            }
        );

        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const RescheduleNewInstituteSingleInClass = (Events, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/RescheduleNewInstituteSingleInClass`,
             {
                Events
            }
        );

        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const FetchInstituteOwnersProfileData = (instituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "FetchInstituteOwnersProfileDataRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/FetchInstituteOwnersProfileData/${instituteId}`
        );

        dispatch({
            type: "FetchInstituteOwnersProfileDataSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "FetchInstituteOwnersProfileDataError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const UpdateInstituteOwnersProfileData = (instituteId, FormData, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteOwnersProfileDataRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/UpdateInstituteOwnersProfileData/${instituteId}`,
            {
                FormData
            }
        );

        dispatch({
            type: "UpdateInstituteOwnersProfileDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteOwnersProfileDataError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const UpdateInstructorsProfileData = (InstructorId, FormData, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteOwnersProfileDataRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/UpdateInstructorsProfileData/${InstructorId}`,
            {
                FormData
            }
        );

        dispatch({
            type: "UpdateInstituteOwnersProfileDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteOwnersProfileDataError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

//Get Institute Notification data
export const GetInstituteNotificationData = (UserId) => async (dispatch) => {
    try {
        console.log("UserId in GetInstituteNotificationData action is:", UserId)

        dispatch({
            type: "GetStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/institute/settings/NotificationsData/${UserId}`
        );

        dispatch({
            type: "GetStudentNotificationDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentNotificationDataFailure",
            payload: error,
        });
    }
};

//Get Instructor Notification data
export const GetInstructorNotificationData = (UserId) => async (dispatch) => {
    try {
        console.log("UserId in GetInstructorNotificationData action is:", UserId)

        dispatch({
            type: "GetStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/instructor/settings/NotificationsData/${UserId}`
        );

        dispatch({
            type: "GetStudentNotificationDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentNotificationDataFailure",
            payload: error,
        });
    }
};

//Update institute Notification Personal data
export const UpdateInstitutePersonalNotificationData = (UserId, notifications, cb) => async (dispatch) => {
    try {
        console.log("UserId in UpdateInstitutePersonalNotificationData action is:", UserId)
        console.log("notifications in UpdateInstitutePersonalNotificationData action is:", notifications)

        dispatch({
            type: "UpdateStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/institute/settings/UpdateNotificationsData/${UserId}`,
            { notifications }
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });
    }
};

//Update Instructor Notification Personal data
export const UpdateInstructorPersonalNotificationData = (UserId, notifications, cb) => async (dispatch) => {
    try {
        console.log("UserId in UpdateInstructorPersonalNotificationData action is:", UserId)
        console.log("notifications in UpdateInstructorPersonalNotificationData action is:", notifications)

        dispatch({
            type: "UpdateStudentNotificationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/instructor/settings/UpdateNotificationsData/${UserId}`,
            { notifications }
        );

        dispatch({
            type: "UpdateStudentNotificationDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateStudentNotificationDataFailure",
            payload: error,
        });
    }
};


export const AddInstituteServiceAreaLocationData = (InstituteId, payload, cb) => async (dispatch) => {
    try {
        console.log("InstituteId in AddInstituteServiceAreaLocationData action is:", InstituteId)

        dispatch({
            type: "AddInstituteServiceAreaLocationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/institute/settings/AddServiceArea/${InstituteId}`,
            { payload }
        );

        dispatch({
            type: "AddInstituteServiceAreaLocationDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "AddInstituteServiceAreaLocationDataFailure",
            payload: error,
        });
    }
};

export const DeleteInstituteServiceAreaLocationData = (InstituteId, cb) => async (dispatch) => {
    try {
        console.log("InstituteId in AddInstituteServiceAreaLocationData action is:", InstituteId)

        dispatch({
            type: "DeleteInstituteServiceAreaLocationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/institute/settings/DeleteServiceArea/${InstituteId}`
        );

        dispatch({
            type: "DeleteInstituteServiceAreaLocationDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "DeleteInstituteServiceAreaLocationDataFailure",
            payload: error,
        });
    }
};

export const AddInstituteCoursesServiceAreaLocationData = (InstituteId, payload, cb) => async (dispatch) => {
    try {
        console.log("InstituteId in AddInstituteServiceAreaLocationData action is:", InstituteId)

        dispatch({
            type: "AddInstituteServiceAreaLocationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/institute/settings/AddInstituteCoursesServiceArea/${InstituteId}`,
            { payload }
        );

        dispatch({
            type: "AddInstituteServiceAreaLocationDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "AddInstituteServiceAreaLocationDataFailure",
            payload: error,
        });
    }
};

export const DeleteInstituteCourseServiceAreaLocationData = (instituteCourseId, InstituteId, cb) => async (dispatch) => {
    try {
        console.log("InstituteId in DeleteInstituteCourseServiceAreaLocationData action is:", InstituteId)

        dispatch({
            type: "DeleteInstituteServiceAreaLocationDataRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/institute/settings/DeleteInstituteCoursesServiceArea/${InstituteId}`,
            {instituteCourseId}
        );

        dispatch({
            type: "DeleteInstituteServiceAreaLocationDataSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "DeleteInstituteServiceAreaLocationDataFailure",
            payload: error,
        });
    }
};

export const FetchInstituteData = (instituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "FetchInstituteDataRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/NewInstitute/FetchInstituteData/${instituteId}`
        );

        dispatch({
            type: "FetchInstituteDataSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "FetchInstituteDataError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const GetStudentDetailsA = (UserId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetStudentDetailsRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/GetStudentDetails/${UserId}`
        );
        dispatch({
            type: "GetStudentDetailsSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentDetailsFailure",
            payload: error,
        });
    }
};


export const GetInstituteAllStudentsScheduleA = (InstituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetInstituteAllStudentsScheduleRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/institite/allstudnets/schedule/${InstituteId}`
        );
        dispatch({
            type: "GetInstituteAllStudentsScheduleSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetInstituteAllStudentsScheduleFailure",
            payload: error,
        });
    }
};

export const GetInstituteAllInstructorsScheduleA = (InstituteId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetInstituteAllInstructorsScheduleRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/institite/allInstructors/schedule/${InstituteId}`
        );
        dispatch({
            type: "GetInstituteAllInstructorsScheduleSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetInstituteAllInstructorsScheduleFailure",
            payload: error,
        });
    }
};

export const GetInstituteSingleInstructorsScheduleA = (InstructorId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetInstituteSingleInstructorsScheduleRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/institite/singleInstructors/schedule/${InstructorId}`
        );
        dispatch({
            type: "GetInstituteSingleInstructorsScheduleSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetInstituteSingleInstructorsScheduleFailure",
            payload: error,
        });
    }
};

export const GetInstructorUnderTrainingStudentsDataA = (InstructorId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetInstructorUnderTrainingStudentsDataRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/institite/singleInstructors/underTrainingStudentsData/${InstructorId}`
        );
        dispatch({
            type: "GetInstructorUnderTrainingStudentsDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetInstructorUnderTrainingStudentsDataFailure",
            payload: error,
        });
    }
};

export const GetInstructorTrainedStudentsDataA = (InstructorId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetInstructorTrainedStudentsDataRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/institite/singleInstructors/TrainedStudentsData/${InstructorId}`
        );
        dispatch({
            type: "GetInstructorTrainedStudentsDataSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetInstructorTrainedStudentsDataFailure",
            payload: error,
        });
    }
};

export const GetStudentsScheduleWithOtherDetailsA = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetStudentsScheduleWithOtherDetailsRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/student/schedule/details/${EnrollmentId}`
        );
        dispatch({
            type: "GetStudentsScheduleWithOtherDetailsSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentsScheduleWithOtherDetailsFailure",
            payload: error,
        });
    }
};

export const GetStudentsScheduleWithOtherDetailsForSpecificInstructorA = (EnrollmentId, InstructorId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetStudentsScheduleWithOtherDetailsRequest",
        });
      
        const { data } = await axiosInstance.post(
            `/api/student/schedule/detailswithinstructor/${EnrollmentId}`,
            { InstructorId } // 👈 sent in body
          );

        dispatch({
            type: "GetStudentsScheduleWithOtherDetailsSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetStudentsScheduleWithOtherDetailsFailure",
            payload: error,
        });
    }
};

export const ChangeInstituteCourseStatus = (InstituteCourseId, newStatus) => async (dispatch) => {
    try {
        dispatch({
            type: "ChangeScheduleStatusRequest",
        });

        // Send EventId and status in the request body
        const { data } = await axiosInstance.put(
            `/api/changeInstituteCoursestatus`,
            { InstituteCourseId, newStatus }  // Send as an object
        );

         // Log the response data to ensure it's structured correctly
         console.log("Response data:", data);


        dispatch({
            type: "ChangeScheduleStatusSuccess",
            payload: data,  // Assuming data contains the updated schedule
        });

        return { success: true, data }; // ✅ Return success status

    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        
        dispatch({
            type: "ChangeScheduleStatusFailure",
            payload: error?.response?.data?.message || error.message, // Provide a specific error message
        });

        return { success: false, error }; // ✅ Return failure status

    }
};

export const UpdateInstructorTrainingHours = (inVehicleHours, inClassHours, onlineHours, InstructorId, cb) => async (dispatch) => {
    try {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/Instructor/UpdateInstructorTrainingHours/${InstructorId}`,
             {
                inVehicleHours, inClassHours, onlineHours
            }
        );

        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursSuccess",
            payload: data,
        });

        cb();
    } catch (error) {
        dispatch({
            type: "UpdateInstituteTrainingAndOfficeHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};

export const FetchInstructorTrainingHours = (InstructorId) => async (dispatch) => {
    try {
        dispatch({
            type: "FetchInstructorTrainingHoursRequest",
        });

        const { data } = await axiosInstance.post(
            `/api/Instructor/FetchInstructorTrainingHours/${InstructorId}`
        );

        dispatch({
            type: "FetchInstructorTrainingHoursSuccess",
            payload: data,
        });

    } catch (error) {
        dispatch({
            type: "FetchInstructorTrainingHoursError",
            payload: error?.response?.data ? error?.response?.data : {},
        });

    }
};


//Student list Enrollment Status Inprogress
export const GetEnrolledStudentBatchDetailsA = (EnrollmentId) => async (dispatch) => {
    try {
        dispatch({
            type: "GetEnrolledStudentBatchDetailsRequest",
        });

        const { data } = await axiosInstance.get(
            `/api/EnrolledLearner/BatchDetails/${EnrollmentId}`
        );

        dispatch({
            type: "GetEnrolledStudentBatchDetailsSuccess",
            payload: data,
        });
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "GetEnrolledStudentBatchDetailsError",
            payload: error,
        });
    }
};


//UpdateLearnerCourseEnrollmentStatus data
export const UpdateLearnerCourseEnrollmentStatusA = (EnrollmentId, status, FirstName, LastName, Email, CourseTitle, cb) => async (dispatch) => {
    try {
        console.log("EnrollmentId in UpdateLearnerCourseEnrollmentStatus action is:", EnrollmentId)

        dispatch({
            type: "UpdateLearnerCourseEnrollmentStatusRequest",
        });
        const { data } = await axiosInstance.post(
            `/api/UpdateLearnerCourseEnrollmentStatus/${EnrollmentId}`,
            { status, FirstName, LastName, Email, CourseTitle } // <-- send the status dynamically
        );

        dispatch({
            type: "UpdateLearnerCourseEnrollmentStatusSuccess",
            payload: data,
        });
        cb();
    } catch (error) {
        CheckLoginServer(error?.response?.data, dispatch);
        dispatch({
            type: "UpdateLearnerCourseEnrollmentStatusError",
            payload: error,
        });
        return Promise.reject(); // Indicate failure
    }
};